import React from "react";
import { Tabs } from "antd";
import history from "../history";

const { TabPane } = Tabs;
export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: "about",
    };
  }

  callback = (key) => {
    console.log("Home.js e", key);
    history.push("/" + key);
  };
  render() {
    const { match } = this.props;
    console.log("Home.js ", match);

    return (
      <div>
        <Tabs
          activeKey={match && match.params && match.params.page}
          type="card"
          size="large"
          onChange={this.callback}
        >
          {/* <TabPane tab="About" key="about">
            <p>
              The purpose of this website to provide Journalists and
              Organizations who find value in the financial data that contains
              information about investments from other countries that do
              business with Military. Please feel free to use this website or
              share this website as you wish. We seek no credit for this
              website.
            </p>
            <br />
            <br />

            <b>Wishing for a better future for Myanmar,</b>
            <br />
            <i>Cheers!</i>
          </TabPane> */}
          <TabPane tab="Updates" key="updates">
            <div>
              <span>
                <code className="mr-2">
                  {new Date("April 10 2021").toDateString()}
                </code>
                <span>Tables can now be grouped</span>
              </span>
            </div>
          </TabPane>
        </Tabs>
      </div>
    );
  }
}
